export default {
  clientId: 'ZybLiGgJGOlepsr3Tu90uTJM8THSp1xi',
  domain: 'otg-terminals.auth0.com',
  callbackUrl:
    process.env.NODE_ENV === 'production'
    //      ? 'http://otg-terminals.s3-website-us-east-1.amazonaws.com'
      ? 'https://d1g8513p78hbe1.cloudfront.net'
      : 'http://localhost:8080/#/callback',
  apiUrl: 'API_IDENTIFIER',
};



// WEBPACK FOOTER //
// ./src/configs/configs.auth0.js